<template>
  <div class="" dir="rtl">
    <div class="vh-100 w-100 mx-0 show">
      <div
        style=""
        class="p-0 h-100 text-white w-sidebar sidebar collapse show"
      >
        <Sidebar />
      </div>
      <div class="main-container col px-0">
        <Navbar />
        <div class="row justify-content-center mx-0">
          <div class="col-md-11 px-0">
            <main class="main px-0 px-md-4 pt-3">
              <slot name="mainView"></slot>
            </main>
          </div>
        </div>
        <!-- Footer logo container -->
        <div class="footer-logo-container">
          <img src="/logo-vertical.png" alt="Logo" class="footer-logo" />
        </div>
        <BottomNavigation />
      </div>
    </div>

    <!-- Modals -->
    <!-- <PlayedTrackInfo /> -->
    <PlayedTracklist />
  </div>
</template>

<script>
// import PlayedTrackInfo from '../../components/Player/PlayedTrackInfo.vue';
import PlayedTracklist from '../../components/Player/PlayedTracklist.vue';
import BottomNavigation from "./BottomNavigation.vue";
import Navbar from "./Navbar.vue";
import Sidebar from "./Sidebar.vue";

export default {
  components: {
    BottomNavigation,
    Navbar,
    Sidebar,
    // PlayedTrackInfo,
    PlayedTracklist,
  },
};
</script>

<style lang="scss">
@import "../../assets/css/mdb.rtl.min";
@import "../../assets/css/custom";

.footer-logo-container {
  position: fixed;
  left: 16px;
  bottom: 16px;
  z-index: 1000;
}

.footer-logo {
  height: 60px;
  width: auto;
}

@media (max-width: 768px) {
  .footer-logo-container {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 70px; // Adjust this value based on your bottom navigation height
  }

  .footer-logo {
    display: none;
  }
}
</style>
